export default __webpack_public_path__ + "static/media/meter.ed74c879.svg";